// src/hooks/useRagSearch.js
import { useState, useRef, useCallback, useEffect } from "react";
import { ragAsk, streamAnswer } from "../service/ragSearch";

const INITIAL = {
  loading: false,
  error: null,
  kind: null,
  query: "",
  results: null,
  requestId: null,
  answer: "",
  citations: [],
  answerNoAnswer: false,
  answerLoading: false,
  answerRequestId: null,
  recurring: null,
};

export default function useRagSearch() {
  const [state, setState] = useState(INITIAL);
  const cancelRef = useRef(null);

  const runQuery = useCallback(async (q) => {
    if (!q || !q.trim()) return;
    if (cancelRef.current) {
      cancelRef.current();
      cancelRef.current = null;
    }
    setState({ ...INITIAL, loading: true, query: q });

    let data;
    try {
      data = await ragAsk(q);
    } catch (e) {
      setState((s) => ({
        ...s,
        loading: false,
        error: e && e.rateLimited ? "rate_limited" : "generic",
      }));
      return;
    }

    if (data.type === "recurring") {
      setState((s) => ({
        ...s,
        loading: false,
        kind: "recurring",
        requestId: data.request_id,
        recurring: data,
      }));
      return;
    }

    setState((s) => ({
      ...s,
      loading: false,
      kind: data.type,
      requestId: data.request_id,
      results: data.results || null,
      answerLoading: data.type === "answer",
    }));

    if (data.type === "answer") {
      cancelRef.current = streamAnswer(q, {
        onToken: (chunk) =>
          setState((s) => ({ ...s, answer: s.answer + chunk })),
        onDone: (done) =>
          setState((s) => ({
            ...s,
            answerLoading: false,
            citations: done.citations || [],
            answerNoAnswer: !!done.no_answer,
            answerRequestId: done.request_id,
          })),
        onError: () =>
          setState((s) => ({
            ...s,
            answerLoading: false,
            error: s.error || "answer_failed",
          })),
      });
    }
  }, []);

  useEffect(
    () => () => {
      if (cancelRef.current) cancelRef.current();
    },
    []
  );

  return { ...state, runQuery };
}
